module.exports = __webpack_public_path__ + "img/jeok-cruz.2846939b.png";